module.exports = "<gw-definition-list title=\"{{ $ctrl.roleName }}\">\n</gw-definition-list>"